export const characterCodes = {
  EOF: -1,
  NEWLINE: 10,
  SPACE: 32,
  BANG: 33,
  DOUBLEQUOTE: 34,
  DOLLAR: 36,
  OPENING_BRACKET: 40,
  CLOSING_BRACKET: 41,
  ASTERISK: 42,
  COMMA: 44,
  DASH: 45,
  DOT: 46,
  LESS_THAN: 60,
  EQUALS: 61,
  GREATER_THAN: 62,
  SQUARE_OPENING_BRACKET: 91,
  BACKSLASH: 92,
  TILDE: 126,
};

export const durationUnitChars = ['n', 's', 'm', 'h', 'd'];
